export default __webpack_public_path__ + "static/media/a036-3.2006f5bb.svg";